// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","BoldHeading":"BoldHeading-2xtwtcwykkk2c828xez9mrf6efsmfen1kf47v7z4k653k81y9ba57c8cvuv4znhg718e1h23a9f4zabrgy3aq72bsk8cnse9mxay8vc","RodoPolicyContent":"RodoPolicyContent-2857yu1mn51j87y1gjj8mj59ey12ny1fzdrse7bpnydfp6rhd2xe2jw5eg5ng2jaw6dkn3ck5brgv4m54b9rqfu8x2gpa8tpyxrp51j","loading":"loading-3tck3j99zmd92kb8ad2m4d36eqvv94nwdx75sxgkna8xnpwd97u1hm326yvfvvjn7fyj3ug1d7n4y5u6gsjzdsuvsr99rakqv66b5wv","pulse":"pulse-3axjspffu283mxp5e6qyxjgvad1h25xpaudccsbb138uk56w8fgrvqbw4yuaeykszqae7uyucj7psddd3djhzp7xfk61zge67tg9y3e"};


//////////////////
// WEBPACK FOOTER
// ./src/views/RodoPolicy/RodoPolicy.module.scss
// module id = 1790
// module chunks = 0